const point = "https://central-backend.cuba-go.com"
const startpoint = `${point}/admin/`
const mediapoint = `${point}/`
const gamepoint = `${point}/`
const socketpoint = `${point}`

const bridgeURL = ""

const livekit = ""
const livekitService = ""
const LIVEKIT_TOKEN = ""

export { point, startpoint, gamepoint, mediapoint, socketpoint, bridgeURL, livekit, livekitService, LIVEKIT_TOKEN }
